import { Link, useLocation } from "react-router-dom";
import { FlaskConical } from "lucide-react";

// Floating admin-only shortcut to the Test Lab (hidden on the lab itself).
export const TestLabChip = ({ user }) => {
  const { pathname } = useLocation();
  if (!user || user.role !== "admin" || pathname.startsWith("/admin/testlab")) return null;
  return (
    <Link to="/admin/testlab" className="fixed bottom-4 right-4 z-[60] inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-[#1A1A1A] text-white text-xs font-semibold shadow-lg hover:bg-[#2E5C55] transition-colors" data-testid="testlab-chip" title="Admin Test Lab">
      <FlaskConical className="h-3.5 w-3.5" /> Test Lab
    </Link>
  );
};
